import { styled } from "@mui/material/styles";
import {
    InternalStandardProps,
    Typography,
    TypographyProps,
} from "@mui/material";

export interface AppTypographyProps
    extends InternalStandardProps<TypographyProps> {
    textColor?: "grey-a100" | "grey-500" | "grey-600" | "black";
}

const StyledTypography = styled(Typography, {
    shouldForwardProp: (prop) => prop !== "textColor",
})<AppTypographyProps>(({ theme, textColor }) => ({
    ...(textColor === "grey-a100" && {
        color: theme.palette.grey.A100,
    }),
    ...(textColor === "grey-500" && {
        color: theme.palette.grey[500],
    }),
    ...(textColor === "grey-600" && {
        color: theme.palette.grey[600],
    }),
    ...(textColor === "black" && {
        color: theme.palette.common.black,
    }),
}));

export const AppTypography = (props: AppTypographyProps) => {
    const { textColor, ...rest } = props;

    return <StyledTypography textColor={textColor} {...rest} />;
};
